module.exports = __webpack_public_path__ + "img/course3.da56bbff.png";